// api/wechat.js
import axios from '@/api'

/**
 * 登出
 */
export const logout = () => {
	return axios.put('/user/logout').then(res => res.data)
}

/**
 * 检测token
 */
export const checkToken = (token) => {
	return axios.get('/user/checkToken', {
		params: { token: token || '' }
	}).then(res => res.data)
}

/**
 * 获取余额
 */
export const getBalance = () => {
	return axios.get('/user/balance').then(res => res.data)
}

/**
 * 获取最近一个月的充值历史
 */
export const lastMonthRecharge = () => {
	return axios.get('/user/lastMonthRecharge').then(res => res.data)
}
/**
 * 获取用户信息
 */
export const getUserInfo = () => {
	return axios.get('/user/get').then(res => res.data)
}
/**
 * 修改用户个人信息
 */
export const modifyBasic = (data) => {
	return axios.post('/user/v1/modify/basic', data).then(res => res.data)
}

/**
 * 修改手机号
 */
export const changeMobile = (data) => {
	return axios.post('/user/v1/change/mobile', data).then(res => res.data)
}
